<template>
    <div>
        <div class="summary">
            <div style="background-color: #b2dfdb">
                <div>
                    <h1>ໃບບິນມື້ນີ້</h1>
                    <p class="amount">{{ todayInvoice.length }}</p>
                    <p>ລາຍການ</p>
                </div>
            </div>
            <div style="background-color: #bbdefb">
                <div>
                    <h1>ໃບບິນທັງໝົດ</h1>
                    <p class="amount">{{ allInvoice.length }}</p>
                    <p>ລາຍການ</p>
                </div>
            </div>
            <div style="background-color: #e1bee7">
                <div>
                    <h1>ຍອດຂາຍມື້ນີ້</h1>
                    <p class="money">{{ todayTotal | formatMoney}}</p>
                    <p class="kip">ກີບ</p>
                </div>
            </div>
            <div style="background-color: #f8bbd0">
                <div>
                    <h1>ຍອດຂາຍທັງໝົດ</h1>
                    <p class="money">{{allTotal | formatMoney}}</p>
                    <p class="kip">ກີບ</p>
                </div>
            </div>
            <div style="background-color: #c8e6c9">
                <div>
                    <h1>ສິນຄ້າທັງໝົດ</h1>
                    <p class="amount">{{ products.length }}</p>
                    <p>ລາຍການ</p>
                </div>
            </div>
        </div>
        <div class="chart">
            <div>
                <line-chart :chart-data="datacollection" :options="chartOptions"/>
            </div>
        </div>
        <div>
            <div></div>
        </div>
    </div>
</template>

<script>
    import {productsCollection, paymentsCollection} from "../firebase";
    import LineChart from "../components/LineChart";


    export default {
        name: "Dashboard",
        components: {LineChart},
        data() {
            return {
                todayInvoice: [],
                allInvoice: [],
                products: [],
                datacollection: {},
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        labels: {
                            fontFamily: 'Noto Sans'
                        }
                    },
                    tooltips: {
                        titleFontFamily: 'Noto Sans',
                        bodyFontFamily: 'Noto Sans',
                        callbacks: {
                            label: function (tooltipItem, data) {
                                const formatter = new Intl.NumberFormat("lo-LA", {
                                    minimumFractionDigits: 0,
                                });

                                let currencySymbol = '₭';
                                /*if (tooltipItem.datasetIndex === 0) currencySymbol = '₭'
                                if (tooltipItem.datasetIndex === 1) currencySymbol = '฿'
                                if (tooltipItem.datasetIndex === 2) currencySymbol = '$'*/

                                let amount = formatter.format(tooltipItem.yLabel)
                                if (isNaN(parseFloat(amount))) amount = formatter.format(tooltipItem.xLabel)

                                return data.datasets[tooltipItem.datasetIndex].label
                                    + ": "
                                    + amount
                                    + currencySymbol
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function (label) {
                                    return label / 1000 + 'K';
                                },
                                fontFamily: 'Noto Sans'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontFamily: 'Noto Sans',
                                fontSize: 14
                            }
                        }]
                    }
                },
            }
        },
        mounted() {
            this.datacollection = {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [
                    {
                        label: 'ຍອດຂາຍປະຈໍາເດືອນ 09/2020',
                        backgroundColor: '#f8bbd0',
                        data: [40, 20, 12, 39, 10, 40, 39, 80, 88, 89, 99, 101]
                    }
                ]
            };
            this.getMonthlyChart();
        },
        firestore: {
            allInvoice: paymentsCollection.orderBy('created', 'desc'),
            products: productsCollection.where('deleted', '==', false).orderBy('created', 'desc'),
        },
        computed: {
            todayTotal: function () {
                return this.todayInvoice.reduce((o, item) => o + item.total, 0);
            },
            allTotal: function () {
                return this.allInvoice.reduce((o, item) => o + item.total, 0);
            },

        },
        methods: {
            getInvoices() {
                paymentsCollection.where('created', '>=', this.getCurrentDate() + ' 00:00:00').where('created', '<=', this.getCurrentDate() + ' 23:59:59').get()
                    .then(res => {
                        this.invoices = [];
                        res.forEach(docSnapshot => {
                            this.todayInvoice.push(docSnapshot.data());
                        });
                    }).catch(err => {
                    console.log(err);
                })
            },
            getMonthlyChart: async function () {
                const {docs} = await paymentsCollection.orderBy('created', 'desc').get();
                /*docs.map(doc => {
                    const { id } = doc
                    const data = doc.data()
                    console.log({ id, ...data })
                })*/
                let g = ['01','02','03','04','05','06','07','08','09','10','11','12',];
                //let groupKey = 0;
                docs.reduce(function (r, o) {
                    const data = o.data()
                    let month = data.created.split(('-'))[1];
                    g = g[month].push({total: data.total});
                    //g.push({month, total: data.total})
                    //(r[m]) ? r[m].created.push(data) : r[m] = {group: String(groupKey++), data: [data]};
                    return r;
                }, {});
                g.forEach(item => {
                    console.log(item);
                })

            }
        },
    }
</script>

<style scoped lang="scss">
    .summary {
        display: flex;
    }

    .summary > div {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 20px;
        background-color: white;
        margin: 10px;
        width: calc(100% / 4);
        height: 180px;
        border-radius: 12px;
        box-shadow: 0 5px 10px #efefef;
        text-align: center;
        color: #fff;

        h1 {
            font-size: 18pt;
            font-weight: bold;
        }

        p.amount {
            font-size: 36pt;
            font-weight: bold;
        }

        p.money {
            margin-top: 18px;
            font-size: 20pt;
            font-weight: bold;
        }

        p.money {
            margin-top: 16px;
            font-size: 20pt;
            font-weight: bold;
        }

        p.kip {
            margin-top: 18px;
        }
    }

    .chart {
        display: flex;
        margin-top: 20px;
    }

    .chart > div {
        flex: 1;
        padding: 10px;
        margin: 10px;
        background-color: white;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 5px 10px #efefef;
        text-align: center;
        color: #fff;
    }
</style>